import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import ServiceWrapper from './serviceWrapper';
import styles from '../styles/configuration.module.scss';
import InputComponent from './inputComponent';
import { displayTbOrGb } from '../helpers/sizesConverter';

function ServiceConfiguration({ service, changeConfigurations, intialConfigs, space, computeResources }) {
    const { t } = useTranslation('configuration');
    const disks = ['ssd', 'hdd'];
    const resources = ['cpu', 'ram'];
    const [options, setOptions] = useState(intialConfigs);
    const [isHidden, setIsHidden] = useState(true);
    const [isMount, setIsMount] = useState(false);

    useEffect(() => {
        if (isMount) {

        }
    }, [options, space]);

    useEffect(() => {
        if (isMount) {
            changeConfigurations({ ...options });
        }
    }, [options]);

    useEffect(() => {
        setIsMount(true);
    }, []);

    return (
        <ServiceWrapper service={service}>
            <div className={'flex ' + styles.configs} onClick={() => setIsHidden(!isHidden)}>
                <div className={styles['arrow-container']}>
                    <div className={`${styles['arrow-element']} ${isHidden ? '' : styles['rotate-forward']}`} />
                </div>
                <p className={'pointer ' + styles.title}>{t('config')}</p>
            </div>
            <div className={styles[isHidden ? 'hide' : 'visible']}>
                <div className={styles['storage-options']}>
                    { disks.filter(disk => !(!space.hdd && disk === 'hdd')).map(disk => (
                    <div key={disk} className={'flex col ' + styles['storage-type']}>
                            <h5>{disk.toUpperCase()}</h5>
                        <InputComponent label={'compute.disk'}
                                        initial={options[disk]}
                                        free={space[disk].free}
                                        usable={space[disk].total}
                                        setSpace={size => setOptions(prevState => ({ ...prevState, [disk]: size }))}
                                        available={true} />
                    </div>)) }
                </div>
                <br />
                <p>{t('compute.description2')}</p>
                <br />
                <div className={styles['storage-options']}>
                    { resources.map(resource => (
                        <label key={resource}>
                            <p><b>{ t(`compute.${resource}`) }</b></p>
                            <p className={styles.edit}>{resource === 'ram' ? displayTbOrGb(computeResources[resource], t) : `${computeResources[resource]} Cores` }</p>
                        </label>))
                    }
                </div>
            </div>
            <style jsx>{`
                select {
                    width: 70px;
                }
            `}</style>
        </ServiceWrapper>
    )
};

export default memo(ServiceConfiguration);
